import { Injectable } from '@angular/core';
import { Poliza, Riesgo } from '../../model/poliza.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PolizaStoreService {
  private polizaSubject = new BehaviorSubject<Poliza<Riesgo>>(null);
  polizaSubject$ = this.polizaSubject.asObservable();

  setPoliza(propuesta: Poliza<Riesgo>): void {
    this.polizaSubject.next(propuesta);
  }

  getPoliza(): Poliza<Riesgo>{
    return this.polizaSubject.value;
  }
  
  limpiarPoliza(): void {
    this.polizaSubject.next(null);
  }

  limpiarStore(): void {
    this.limpiarPoliza();
  }
}
